export default "__VITE_ASSET__307e9ca8__"